import { UseUserAuth } from "./context/UseAuthContext";
import PageNav from "./components/PageNav";
import { useState, useEffect } from "react";
import { CurrencyDollarIcon, ExclamationCircleIcon, UserGroupIcon, KeyIcon } from "@heroicons/react/20/solid";
import { NavLink } from "react-router-dom";
import { useNavigate } from 'react-router-dom'; 

export default function Account() {
  const { user } = UseUserAuth();
  const [isLoading, setIsLoading] = useState(false);

  console.log("user-acc",user)
  // At the top of your Account component
  console.log("Current user state:", {
  user: user ? user.email : "no user",
  emailVerified: user.emailVerified ,
  
});
  const [credits, setCredits] = useState(0);
  const emailVerified = user.emailVerified;
  const navigate = useNavigate();

  const [userInfo, setUserInfo] = useState(null);
  const [organizationMembers, setOrganizationMembers] = useState([]);
  //console.log("acc-path", `${process.env.REACT_APP_BACKEND}/user/getNumCredits`)
  
   // Function to update email verification status on the backend
   const updateEmailVerified = async () => {
    try {
      const idToken = await user.getIdToken();
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND}/user/usersEmailVerificationInfo`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: idToken,
          },
          body: JSON.stringify({ emailVerified : emailVerified }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update email verification status");
      } else {
        console.log("Email verification status updated successfully");
        localStorage.setItem('emailVerifiedStatus', 'true');  // Store in localStorage
      }
    } catch (error) {
      console.error("Error updating email verification status:", error);
    }
  };

  // Function to fetch user information from the backend
  const fetchUserInfo = async () => {
    try {
      const idToken = await user.getIdToken();
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND}/user/getUserInfo`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: idToken,
          },
        }
      );
      if (response.ok) {
        const userData = await response.json();
        console.log("User data received:", userData);
      console.log("Is educator?", userData.userType === 'educator');
      console.log("Is admin?", userData.userRole === 'admin');
      console.log("Has joinCode?", !!userData.joinCode);
        setUserInfo(userData);
        return userData;
      } else {
        console.error("Failed to fetch user information");
      }
    } catch (error) {
      console.error("Error fetching user information:", error);
    }
    return null;
  };

  // Function to fetch credit information from the backend
  const fetchCreditInfo = async () => {
    try {
      const idToken = await user.getIdToken();
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND}/user/getNumCredits`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: idToken,
          },
        }
      );
      if (response.ok) {
        const userCredits = await response.json();
        setCredits(userCredits);
      } else {
        console.error("Failed to fetch credit information");
      }
    } catch (error) {
      console.error("Error fetching credit information:", error);
    }
  };

  // Function to fetch organization members
  const fetchOrganizationMembers = async (organizationID) => {
    try {
      const idToken = await user.getIdToken();
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND}/user/getOrganizationMembers`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: idToken,
          },
          body: JSON.stringify({ organizationID }),
        }
      );
      if (response.ok) {
        const members = await response.json();
        console.log("Organization members received:", members);
        setOrganizationMembers(members);
      } else {
        console.error("Failed to fetch organization members");
      }
    } catch (error) {
      console.error("Error fetching organization members:", error);
    }
  };

  const checkAndFetchUserData = async () => {
    if (user) {
      const hasUpdatedEmailVerified = localStorage.getItem('emailVerifiedStatus') === 'true';
      console.log("hasUpdatedEmailVerified - acc", hasUpdatedEmailVerified);
      if (emailVerified && !hasUpdatedEmailVerified) {
        console.log("updating acc")
        await updateEmailVerified();
      }
      // Fetch user information
      const userData = await fetchUserInfo();

      await fetchCreditInfo();

      // If user is an educator admin with an organizationID, fetch organization members
      if (userData && userData.userType === 'educator' && userData.organizationID) {
        await fetchOrganizationMembers(userData.organizationID);
      }

      if (credits > 0 && userData.userType !== 'educator') {
        navigate('/create');
      }
    }
  };

  useEffect(() => {
    const justVerified = new URLSearchParams(window.location.search).get('verified') === 'true';
  
  if (justVerified && user) {
    // Show a loading message
    setIsLoading(true);
    
    // Wait a bit for Firebase to update its systems
    setTimeout(async () => {
      try {
        // Force refresh the token
        await user.getIdToken(true);
        // Now check verification status
        if (user.emailVerified) {
          await updateEmailVerified();
        }
        await checkAndFetchUserData();
      } catch (err) {
        console.error("Error after verification:", err);
      } finally {
        setIsLoading(false);
      }
    }, 5000); // Wait 3 seconds
  } else {
    // Normal flow
     checkAndFetchUserData();
  }
}, [user, emailVerified]);

 // Format date function
 const formatDate = (timestamp) => {
  if (!timestamp) return 'N/A';
  const date = new Date(timestamp);
  return date.toLocaleDateString();
};

  // Conditional rendering based on email verification status
// Keep your existing condition and structure, just update the content inside the span
if (!emailVerified) {
  return (
    <div>
      <PageNav className="absolute inset-x-0 top-0 z-50" />
      <Heading />
      <div className="flex justify-center bg-white px-6 py-10 lg:px-8">
        <div
          role="list"
          className="mt-8 max-w-2xl space-y-8 text-gray-800 text-justify"
        >
          <div className="flex gap-x-3">
            <ExclamationCircleIcon
              className="mt-1 h-5 w-10 flex-none text-indigo-600"
              aria-hidden="true"
            />
            <div className="space-y-4">
              {/* Main message */}
              <p>
                Please verify your email address. An email verification link has been sent to your email from 
                <span className="font-semibold"> noreply@mytalemaker.com</span>
              </p>
              
              {/* Additional helpful information boxes */}
              <div className="bg-gray-50 p-3 rounded-md border-l-4 border-indigo-600">
                <p><strong className="font-semibold">Can't find the email? </strong> 
                Please check your spam or junk folder.</p>
              </div>
              
              <div className="bg-gray-50 p-3 rounded-md border-l-4 border-indigo-600">
                <p><strong className="font-semibold">Using a mobile phone? </strong> 
                You may need to log in again after verification.</p>
              </div>
              
              <div className="bg-gray-50 p-3 rounded-md border-l-4 border-indigo-600">
                <p><strong className="font-semibold">Using multiple browsers? </strong> 
                Each browser requires a separate login.</p>
              </div>
              
              <p className="text-center text-gray-600">
                If you have already verified your email, please log out and log in again.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

return (
  <>
    <PageNav className="absolute inset-x-0 top-0 z-50" />
    <Heading />
    {isLoading ? (
      <div className="flex justify-center bg-white px-6 py-10 lg:px-8">
        <div className="mt-8 max-w-2xl space-y-8 text-gray-800 text-center">
          <p className="font-semibold">Email verification successful!</p>
          <p>Please wait a moment while we update your account...</p>
        </div>
      </div>
    ) : (
      <>
        {/* Credit Status Section */}
        <div className="flex justify-center bg-white px-6 py-6 lg:px-8">
          <div
            role="list"
            className="mt-4 max-w-2xl space-y-8 text-gray-600 text-justify"
          >
            <div className="flex gap-x-3">
              <CurrencyDollarIcon
                className="mt-1 h-5 w-10 flex-none text-indigo-600"
                aria-hidden="true"
              />
              <span>
                <strong className="font-semibold text-gray-900">
                  Current Credit Status:{" "}
                </strong>
                Your available credit balance is {credits || 0} credits.
                {credits > 0 ? (
                  <span> Please proceed by clicking on the
                    <NavLink
                      to="/create"
                      className="font-semibold text-gray-700 hover:text-gray-500 underline"
                    > create page </NavLink> to create your custom book.
                  </span>
                ) : (
                  <span> Please proceed by clicking on the{" "}
                    <NavLink
                      to={`/?section=pricing`}
                      className="font-semibold text-gray-700 hover:text-gray-500 underline"
                    >
                      pricing page
                    </NavLink>{" "} to buy credits.
                  </span>
                )}
              </span>
            </div>
          </div>
        </div>

        {/* Educator Section - Only display for educator users */}
        {userInfo && userInfo.userType === 'educator' && (
          <div className="flex justify-center bg-white px-6 pb-10 lg:px-8">
            <div className="mt-4 max-w-3xl w-full">
              {/* Admin Join Code Panel - Only for admins */}
              {userInfo.userRole === 'admin' && userInfo.joinCode && (
                <div className="bg-indigo-50 p-4 rounded-lg mb-6 border border-indigo-200">
                  <div className="flex items-start gap-x-3">
                    <KeyIcon className="h-6 w-6 text-indigo-600" aria-hidden="true" />
                    <div className="space-y-2">
                      <h3 className="font-semibold text-gray-900">Organization Join Code</h3>
                      <p className="text-sm text-gray-600">
                        Share this code with other educators to join your organization:
                      </p>
                      <div className="bg-white px-4 py-2 rounded-md border border-indigo-300 font-mono text-lg font-semibold text-indigo-700 inline-block">
                        {userInfo.joinCode}
                      </div>
                      <p className="text-xs text-gray-500 mt-2">
                        Note: Educators who join will need to verify their email before accessing your organization.
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {/* Organization Members Table */}
              <div className="bg-white rounded-lg shadow overflow-hidden border border-gray-200">
                <div className="px-4 py-5 sm:px-6 bg-gray-50 border-b border-gray-200">
                  <div className="flex items-center">
                    <UserGroupIcon className="h-5 w-5 text-indigo-600 mr-2" aria-hidden="true" />
                    <h3 className="text-lg font-medium leading-6 text-gray-900">
                      {userInfo.userRole === 'admin' ? 'Your Organization Members' : 'Organization Members'}
                    </h3>
                  </div>
                  <p className="mt-1 max-w-2xl text-sm text-gray-500">
                    {userInfo.orgName ? userInfo.orgName : 'Your Organization'}
                  </p>
                </div>
                
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Name
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Email
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Role
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Joined
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {organizationMembers.length > 0 ? (
                        organizationMembers.map((member, index) => (
                          <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                              {member.name || 'N/A'}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              {member.emailAdd}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                                member.userRole === 'admin' ? 'bg-indigo-100 text-indigo-800' : 'bg-green-100 text-green-800'
                              }`}>
                                {member.userRole === 'admin' ? 'Administrator' : 'Member'}
                              </span>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              {formatDate(member.createdAt)}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="px-6 py-4 text-center text-sm text-gray-500">
                            {userInfo.userRole === 'admin' ? 'No members have joined your organization yet.' : 'No other members in this organization yet.'}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    )}
  </>
);
}
function Heading() {
  const { user } = UseUserAuth();
  const [userName, setUserName] = useState("");
 // console.log("create user", user);

 const fetchUserName = async () => {
  try {
    const idToken = await user.getIdToken();
    const response = await fetch(`${process.env.REACT_APP_BACKEND}/user/getUserName`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: idToken,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch user name");
    }

    const data = await response.json();
    setUserName(data);
  } catch (error) {
    console.error("Error fetching user name:", error);
  }
};

useEffect(() => {
  if (user) {
    fetchUserName();
  }
}, [user]);

return (
  <div className="flex justify-center text-lg font-semibold p-4 box mt-3 text-center text-indigo-600">
    Welcome <br />
    {userName || (user ? (user.displayName ? user.displayName : user.email) : "Guest")}
  </div>
);
}
